import { Reducer } from "redux";
import { IPoliticalRegimeState, IPoliticalRegimeActionTypes } from "./Types";

const initialState: IPoliticalRegimeState = {
  results: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
};
const reducer: Reducer<IPoliticalRegimeState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME: {
      return {
        ...state,
        errorMessage: "",
        isError: false,
        isLoading: true,
        politicalRegimeList: [],
      };
    }
    case IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME_SUCCESS: {
      return {
        ...state,
        errorMessage: "",
        isError: false,
        isLoading: false,
        politicalRegimeList: action.payload,
      };
    }
    case IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload,
        isError: true,
        isLoading: false,
        politicalRegimeList: [],
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as PoliticalRegimeReducer };
